const ATTRIBUTE_MAPPING_STEPS = [
  'CreateAccount',
  'UpdateAccount',
  'EnableAccount',
  'DisableAccount',
  'RemoveAccount',
];

// Shared step mapping: displayName -> stepName
export const STEP_MAPPING: Record<string, string> = {
  'Application Details': 'General',
  'Connection Setup': 'Connection',
  Provisioning: 'Provisioning',
  'Create Account': 'CreateAccount',
  'Update Account': 'UpdateAccount',
  'Enable Account': 'EnableAccount',
  'Disable Account': 'DisableAccount',
  'Remove Account': 'RemoveAccount',
  'Add Access': 'AddAccess',
  'Remove Access': 'RemoveAccess',
  Confirmation: 'Confirmation',
};

export const getActualStepName = (displayName: string): string =>
  STEP_MAPPING[displayName] || displayName;

export default ATTRIBUTE_MAPPING_STEPS;
